

interface EmailInputProps {
  label: string;
  textValue: string | null;
  onChange: (e: any) => void;
  isValid : boolean;
}

function EmailInput({
  label,
  textValue,
  onChange,
  isValid
}: EmailInputProps) {
  return (
      <div className="form-group">
        <label className="control-label">{label}</label>
        <div className="text-area-noconfidential-container">
            <input
                className={isValid ? "form-control" : "form-control is-invalid"}
                type ="email"
                value={textValue ?? ''}
                onChange={onChange}
              />
          
        </div>
      </div>
  );
}

export default EmailInput;
